<template>
  <div class="main-big-box">
    <div class="banner-box">
      <el-carousel height="400px">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img style="width: 800px;height: 400px;" :src="item.Url" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="main-content">
      <div class="hot-goods">
        <div class="hot-left">
          <img src="../../assets/bktj.png" alt="">
        </div>
        <div class="hot-right">
          <div class="goods-item" v-for="(goods,i) in goodsList" :key="i">
            <img :src="goods.MainPic" alt="" @click="goGoodsDetail(goods)">
            <p>{{goods.ProName}}</p>
            <p>
              <span class="redTxt">￥{{goods.Price}}</span>
              <span class="lineTxt">￥{{goods.LinePrice}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="hot-brands">
        <div class="brands-title">
          <span class="bold-txt">热门品牌</span>
          <span>全球精选，一网打尽</span>
        </div>
        <div class="brands-img">
          <div class="img-box" v-for="(item, index) in brandsData" :key="index">
            <img :src="item.BrandPic" style="width:100%;height:100%;">
          </div>
        </div>
      </div>
      <div class="floor-box" v-for="(floor, id) in floorGoods" :key="id">
        <div class="floor-title">
          <span class="txt-left">{{floor.id}}F {{floor.name}}</span>
          <span class="txt-right">更多商品 <i class="el-icon-arrow-down el-icon-more"></i></span>
        </div>
        <div class="floor-img">
          <div class="img-left">
            <img :src="floor.imgUrl" alt="">
          </div>
          <div class="img-right">
            <div class="goods-item" v-for="(spu,j) in floor.list" :key="j">
              <img :src="spu.MainPic" alt="" @click="goGoodsDetail(spu)">
              <p>{{spu.ProName}}</p>
              <p>
                <span class="redTxt">￥{{spu.Price}}</span>
                <span  class="lineTxt">￥{{spu.LinePrice}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { 
  GetRecommendProductListBussiness,
  NaviDetail,
  BusinessNaviSpuList,
  GetRecommendBannerlist
} from "../../api/api"
export default {
  name: 'AXcontent',
  data(){
    return{
      goodsList: [],
      brandsData: [],
      naviSpuList: [],
      televisionList: [],
      bannerList: [],
      floorGoods: [{
        id: 1,
        name: '冰箱',
        imgUrl: require('../../assets/bxjx.png'),
        list: []
      },{
        id: 2,
        name: '电视',
        imgUrl: require('../../assets/aitv.png'),
        list: []
      },{
        id: 3,
        name: '空调',
        imgUrl: require('../../assets/air.png'),
        list: []
      },{
        id: 4,
        name: '洗衣机',
        imgUrl: require('../../assets/wash.png'),
        list: []
      },]
    }
  },
  created(){
    this.getGoodsList()
    this.getBrandList()
    this.getBusinessNaviSpuList()
    this.getBanner()
  },
  methods:{
    getBanner(){
      let params = {
        keyId: 'Banner'
      }
      GetRecommendBannerlist(params).then(res => {
        if(res.data.success){
          this.bannerList = res.data.response.Banners || []
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    goGoodsDetail(val){
      this.$router.push({path:'/home/goodsDetail',query: {spuId: val.Id}})
    },
    getGoodsList(){
      let params = {
        position: 0,
        pageIndex: 1,
        pageSize: 10
      }
      GetRecommendProductListBussiness(params).then(res => {
        if(res.data.success){
          let list = res.data.response.data || []
          if(list.length >= 4){
            this.goodsList = list.slice(0,4)
          } else{
            this.goodsList = list
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getBrandList(){
      let params = {
        naviId: 1
      }
      NaviDetail(params).then(res => {
        if(res.data.success){
          this.brandsData = res.data.response.Brands || []
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    getBusinessNaviSpuList(){
      let params = {
        typeId: 64,
        sortBy: 0,
        pageIndex: 1,
        pageSize: 10
      }
      BusinessNaviSpuList(params).then(res => {
        if(res.data.success){
          let list = res.data.response.data || []
          if(list.length >= 6){
            this.floorGoods[0].list = list.slice(0,6)
          } else{
            this.floorGoods[0].list = list
          }
        } else{
          this.$message.error(res.data.msg)
        }
      }).then(res => {
        BusinessNaviSpuList({
          typeId: 72,
          sortBy: 0,
          pageIndex: 1,
          pageSize: 10
        }).then(res => {
          if(res.data.success){
            let list = res.data.response.data || []
            if(list.length >= 6){
              this.floorGoods[1].list = list.slice(0,6)
            } else{
              this.floorGoods[1].list = list
            }
          } else{
            this.$message.error(res.data.msg)
          }
        })
      }).then(res => {
        BusinessNaviSpuList({
          typeId: 1,
          sortBy: 0,
          pageIndex: 1,
          pageSize: 10
        }).then(res => {
          if(res.data.success){
            let list = res.data.response.data || []
            if(list.length >= 6){
              this.floorGoods[2].list = list.slice(0,6)
            } else{
              this.floorGoods[2].list = list
            }
          } else{
            this.$message.error(res.data.msg)
          }
        })
      }).then(res => {
        BusinessNaviSpuList({
          typeId: 78,
          sortBy: 0,
          pageIndex: 1,
          pageSize: 10
        }).then(res => {
          if(res.data.success){
            let list = res.data.response.data || []
            if(list.length >= 6){
              this.floorGoods[3].list = list.slice(0,6)
            } else{
              this.floorGoods[3].list = list
            }
          } else{
            this.$message.error(res.data.msg)
          }
        })
      })
    },

  }
}
</script>
<style lang="scss" scoped>
.main-big-box{
  background: #F4F4F4;
  .banner-box{
    width: 800px;
    height: 400px;
    margin: 0 auto;
    padding: 20px 0;
  }
  .redTxt{
    font-size: 24px;
    font-weight: bold;
    color: #f40000;
  }
  .lineTxt{
    font-size: 18px;
    color: #999;
    text-decoration: line-through;
    margin-left: 6px;
  }
  .main-content{
    width: 1200px;
    margin: 0 auto;
    .hot-goods{
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #fff;
      margin-bottom: 32px;
      .hot-left{
        width: 242px;
        height: 332px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .hot-right{
        flex: 1;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .goods-item{
          width: 200px;
          text-align: left;
          color: #333;
          >p{
            margin: 5px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          img{
            width: 200px;
            height: 200px;
            display: block;
            cursor: pointer;
          }
          // span{
          //   display: block;
          // }
        }
      }
    }
    .hot-brands{
      text-align: left;
      margin-bottom: 32px;
      .brands-title{
        font-size: 14px;
        color: #999;
        line-height: 20px;
        margin-bottom: 16px;
        .bold-txt{
          font-size: 24px;
          font-weight: bold;
          color: #333;
          line-height: 33px;
          margin-right: 12px;
        }
      }
      .brands-img{
        width: 1202px;
        overflow: hidden;
        clear: both;
        .img-box{
          float: left;
          width: 198px;
          height: 125px;
          background: #FFFFFF;
          border: 1px solid #EAEAEA;
          text-align: center;
          // padding: 40px 27px 41px 28px;
          // display: table-cell; //主要是这个属性
          // vertical-align: middle;
          // text-align: center;
          // img{
          // }
        }
      }
    }
    .floor-box{
      .floor-title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        .txt-left{
          font-size: 24px;
          font-weight: bold;
          color: #333;
          line-height: 33px;
        }
        .txt-right{
          font-size: 16px;
          color: #999;
          line-height: 22px;
        }
      }
      .floor-img{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fff;
        margin-bottom: 32px;
        .img-left{
          width: 366px;
          height: 672px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .img-right{
          flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          padding: 0 44px;
          .goods-item{
            width: 200px;
            margin-bottom: 24px;
            >p{
              margin: 5px 0;
              text-align: left;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            img{
              width: 200px;
              height: 200px;
              display: block;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>